<template>
  <a :href="link">
    <div class="group w-full h-48 perspective">
      <div
        class="relative w-full h-full duration-500 transition-transform transform-style preserve-3d group-hover:rotate-y-180"
      >
        <!-- Front -->
        <div
          class="absolute inset-0 rounded-lg bg-gray-800 text-white p-6 flex items-center justify-center backface-hidden"
        >
          <h3 class="font-semibold text-lg text-center">{{ title }}</h3>
        </div>

        <!-- Back -->
        <div
          class="absolute inset-0 rounded-lg bg-indigo-300 text-gray-900 p-4 flex items-center justify-center rotate-y-180 backface-hidden"
        >
          <p class="text-sm text-center">{{ description }}</p>
        </div>
      </div>
    </div>
  </a>
</template>

<script setup lang="ts">
defineProps<{ title: string; description: string; link: string }>();
</script>

<style scoped>
.perspective {
  perspective: 1000px;
}
.preserve-3d {
  transform-style: preserve-3d;
}
.backface-hidden {
  backface-visibility: hidden;
}
.rotate-y-180 {
  transform: rotateY(180deg);
}
</style>
